import { useState } from 'react';

import AuthService from '@/services/auth.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import { useDropdownPopover } from '@/shared-components/dropdown';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import { assignLocalizedPublicPath } from '@/utils/localePublicUrl';

import './styles/Header.css';

export default function Header({
  artworksCount = 0,
  onBeginClick,
  hasPaymentMethod,
  subscriptionState = 'pending',
}) {
  const [openMenu, setOpenMenu] = useState(false);
  const { rootRef, triggerRef, menuId, close, toggle, handleTriggerKeyDown } = useDropdownPopover({
    open: openMenu,
    onOpenChange: setOpenMenu,
    idPrefix: 'verify-gallery-actions',
  });

  const isTrialing = subscriptionState === 'trialing';
  const buttonLabel = isTrialing
    ? 'Free trial'
    : hasPaymentMethod
      ? 'Subscription active'
      : 'Subscription pending';

  return (
    <>
      <SuarteName className="verify-gallery__suarte-name" />

      <div className="verify-gallery__menu-actions">
        <button
          type="button"
          className={`verify-gallery__add-payment-btn${hasPaymentMethod ? ' verify-gallery__add-payment-btn--saved' : ''}`}
          disabled
        >
          {buttonLabel}
        </button>

        {/* Menú de tres puntos */}
        <div
          className="verify-gallery__menu-container"
          ref={(node) => {
            rootRef.current = node;
          }}
        >
          <button
            type="button"
            className="verify-gallery__menu-dots"
            aria-label="Open menu"
            aria-haspopup="menu"
            aria-expanded={openMenu}
            aria-controls={menuId}
            onClick={toggle}
            onKeyDown={handleTriggerKeyDown}
            ref={triggerRef}
          >
            ⋯
          </button>

          {openMenu && (
            <div id={menuId} className="verify-gallery__menu-options" role="menu">
              <button
                className="verify-gallery__menu-option"
                onClick={() => {
                  close();
                  assignLocalizedPublicPath('/guidelines-upload-artworks');
                }}
              >
                Artwork Guidelines
              </button>

              <button
                className="verify-gallery__menu-option"
                onClick={() => {
                  close();
                  window.open('https://wa.me/34628171410', '_blank'); // WhatsApp
                }}
              >
                Contact us
              </button>

              <button
                className="verify-gallery__menu-option"
                onClick={() => {
                  close();
                  AuthService.logout();
                }}
              >
                Log out
              </button>
            </div>
          )}
        </div>
      </div>

      {artworksCount >= 3 ? (
        <>
          <ContinueButton
            className="verify-gallery__gallery-profile-verified-button"
            onClick={onBeginClick}
          >
            Begin my journey
          </ContinueButton>
        </>
      ) : null}
    </>
  );
}
